<template>
  <component :is="typeData === undefined ? 'div' : 'b-card'">
    <b-alert variant="danger" :show="typeData === undefined">
      <h4 class="alert-heading">獲取商品類別時出錯</h4>
      <div class="alert-body">
        找不到相關商品類別記錄。請查看
        <b-link class="alert-link" :to="{ name: 'types-list' }">
          商品類別列表
        </b-link>
      </div>
    </b-alert>
    <type-edit-tab-information
      v-if="typeData"
      :type-data="typeData"
      class="p-sm-2"
      @refetch-data="refetchData"
    />

  </component>
</template>

<script>
import { BCard, BAlert, BLink, BTabs, BTab } from "bootstrap-vue";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import store from "@/store";
import router from "@/router";
import typeStoreModule from "../typeStoreModule";
import typeEditTabInformation from "./typeEditTabInformation.vue";

export default {
  components: {
    typeEditTabInformation,
    BCard,
    BAlert,
    BTabs,
    BTab,
    BLink,
  },
  setup() {
    const typeData = ref({ id: 0 });
    const type = {
      id: 0,
      is_active:1
    };

    const type_APP_STORE_MODULE_NAME = "type";

    if (!store.hasModule(type_APP_STORE_MODULE_NAME))
      store.registerModule(type_APP_STORE_MODULE_NAME, typeStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(type_APP_STORE_MODULE_NAME))
        store.unregisterModule(type_APP_STORE_MODULE_NAME);
    });

    const refetchData = () => {
      if (router.currentRoute.name == "product-type-create") {
        typeData.value = type;
      } else {
        store
          .dispatch("type/fetchType", { id: router.currentRoute.params.id })
          .then((response) => {
            typeData.value = response.data.product_category;
            console.log(unitData.value)
          })
          .catch((error) => {
            console.log("error when fetching type", error);
            if (error.response.status === 404) {
              unitData.value = undefined;
            }
          });
      }
    };

    onMounted(() => {
      refetchData();
    });

    return {
      typeData,
      refetchData,
    };
  },
};
</script>
